import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { CurrentUserModel } from '@shared/common/models';
import { SidenavUserMenuComponent } from './toolbar-user-menu/toolbar-user-menu.component';

@Component({
    selector: 'vex-toolbar-user',
    templateUrl: './toolbar-user.component.html',
    standalone: true,
    imports: [MatRippleModule, MatIconModule],
})
export class ToolbarUserComponent {
    public currentUser = inject(CurrentUserModel);
    dropdownOpen = false;

    constructor(
        private popover: VexPopoverService,
        private cd: ChangeDetectorRef,
    ) {}

    showPopover(originRef: HTMLElement) {
        this.dropdownOpen = true;
        this.cd.markForCheck();

        const popoverRef = this.popover.open({
            content: SidenavUserMenuComponent,
            origin: originRef,
            offsetY: 0,
            position: [
                {
                    originX: 'center',
                    originY: 'top',
                    overlayX: 'center',
                    overlayY: 'bottom',
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                },
            ],
        });

        popoverRef.afterClosed$.subscribe(() => {
            this.dropdownOpen = false;
            this.cd.markForCheck();
        });
    }
}
